import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './providers/theme/theme';
import AppRouter from './routers/AppRouter';

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ThemeProvider theme={theme}>
                    <BrowserRouter>
                        <AppRouter />
                    </BrowserRouter>
                </ThemeProvider>
            </PersistGate>
        </Provider>
    )
}

export default App
